// extracted by mini-css-extract-plugin
export default {"row":"_2mUCx"};